import { useCustomMutation } from "@refinedev/core";
import { useRef } from "react";
import { Country } from "../../store/useMarketplaceStore";

type AuthorizationResponse = {
  authorizationUrl: string;
};

// Sends the seller to Amazon to authorize an existing store again. Amazon
// redirects back to /store/create, where SyncrosaleLayout picks up the
// "reAuthenticating" flag and shows ReAuthenticationCallback.
export const useStartReAuthorization = () => {
  const { mutate, isLoading } = useCustomMutation<AuthorizationResponse>();
  // isLoading only flips after a render and resets on success while the browser
  // is still redirecting, so a second click could send another start request.
  const inFlight = useRef(false);

  const startReAuthorization = (marketplace: Country) => {
    if (inFlight.current) return;
    inFlight.current = true;

    mutate(
      {
        url: "authorization/start",
        method: "put",
        values: {
          marketplaceId: marketplace.id,
        },
      },
      {
        onError: () => {
          inFlight.current = false;
        },
        onSuccess: (data) => {
          localStorage.setItem("reAuthenticating", "true");
          localStorage.setItem("marketplaceId", marketplace.id.toString());
          window.location.assign(
            data.data.authorizationUrl +
              "&state=" +
              marketplace.amazonID +
              "&redirect_uri=" +
              encodeURIComponent(window.location.origin + "/store/create"),
          );
        },
      },
    );
  };

  return { startReAuthorization, isLoading };
};
